export const API = window.API_URL || '/proxy/';

export const API_USER = `${API}intranetemployee/v1/api/public/`;
export const API_USER_ADMIN = `${API}intranetemployee/v1/api/sadmin/`;
export const API_PROFILE = `${API}intranetprofiles/v1/api/`;
export const API_MENU = `${API}intranetdailymenu/v1/api/public/`;
export const API_NOTIFICATIONS_CONTROLLER = `${API}intranetnotifications/v1/api/notifications/`;
export const API_NOTIFICATIONS = `${API}intranetnotifications/v1/api/notificationuser/`;
export const API_SHIPMENT = `${API}intranetparcel/v1/api/shipment/`;
export const API_CMS = `${API}intranetcms/v1/api/cms/`;
export const API_CMS_PUBLIC = `${API}intranetcms/v1/api/public/`;
export const API_CMS_DOCUMENTS = `${API}intranetcms/v1/api/cms/documents`;
export const API_DOCUMENTS_DOWNLOAD = `${API}/documents/documents`;
export const API_INTRANET = `${API}intranetcms/v1/api/public/`;
export const API_SOCIAL = `${API}intranetsocial/v1/api/public/`;
export const API_COMMENTS = `${API}intranetsocial/v1/api/`;
export const API_SEARCH = `${API}intranetsearch/v1/api/`;
export const HEALTHY_GUIDE_URL = `${API}files/healthyguide/guia-saludable.pdf`;
export const API_EVENTS = `${API}intranetcms/v1/api/public/events/`;
export const API_EVENTS_USER = `${API}intranetcms/v1/api/public/eventuser/`;
export const API_VIDEOS = `${API}intranetcms/v1/api/cms/videos/mux?id=`;
export const API_SEND_EMAIL = `${API}intranetsocial/v1/api/office365/outlook/sendMail`;
export const API_SEND_EMAIL_IRPF = `${API}intranetsocial/v1/api/sendmail/sendMailIrfp`;
export const API_SEND_EMAIL_IRPF_ADMIN = `${API}intranetsocial/v1/api/sendmail/admin/sendMailIrfp`;
export const API_SEND_EMAIL_USERS_REGISTRATION = `${API}intranetemployee/v1/api/public/irpf/irpfdata/sendMail/altas`;
export const API_SEND_EMAIL_USERS_DEREGISTRATION = `${API}intranetemployee/v1/api/public/irpf/irpfdata/sendMail/bajas`;
export const API_SEND_EMAIL_SEARCH_ID = `${API}intranetemployee/v1/api/public/irpf/irpfdata/sendMail/search`;
export const API_SEND_AUDIENCES_BY_EMAIL = `${API}intranetsocial/v1/api/office365/outlook/sendMailAudience`;
export const API_SEND_BY_EMAIL_AUDIENCES = `${API}intranetsocial/v1/api/sendmail/sendMailWithAudience`;
export const API_PRESS_RESUME = `${API}intranetcms/v1/api/public/newsreviews`;
export const API_DIGITAL_AUDIENCE = `${API}intranetcms/v1/api/public/digitalAudiences`;
export const API_DIGITAL_AUDIENCE_RECENT = `${API}intranetcms/v1/api/public/digitalAudiences/recent`;
export const API_RADIO_AUDIENCE = `${API}intranetcms/v1/api/public/radioAudiences`;
export const API_RADIO_AUDIENCE_RECENT = `${API}intranetcms/v1/api/public/radioAudiences/recent`;
export const API_RRSS_AUDIENCE = `${API}intranetcms/v1/api/public/rrssAudiences`;
export const API_RRSS_AUDIENCE_RECENT = `${API}intranetcms/v1/api/public/rrssAudiences/recent`;
export const API_STRATEGY = `${API}intranetcms/v1/api/public/strategy`;
export const API_STRATEGY_RECENT = `${API}intranetcms/v1/api/public/strategy/recent`;
export const API_NEWS_REVIEWS = `${API}intranetcms/v1/api/public/newsreviews/recent`;
export const API_AUDIENCES = `${API}intranetcms/v1/api/public/shares/`;
export const API_PRESS_DOWNLOAD = `${API}newsreview/newsreview`;
export const API_DIGITAL_DOWNLOAD = `${API}digitalAudience/digitalAudience`;
export const API_RRSS_DOWNLOAD = `${API}digitalAudience/digitalAudience`;
export const API_RADIO_DOWNLOAD = `${API}radioAudience/radioAudience`;
export const API_STRATEGY_DOWNLOAD = `${API}digitalAudience/digitalAudience`;
export const API_EMPLOYEE_CERTIFICATE_LIST = `${API}intranetemployee/v1/api/public/irpf/find/retenciones`;
export const API_EMPLOYEE_LIST = `${API}intranetemployee/v1/api/public/user/filter`;
export const API_EMPLOYEE_HCM_LIST = `${API}intranetemployee/v1/api/public/user/filterHcm`;
export const API_FOOD_TICKETS = `${API}intranetemployee/v1/api/public/mealvoucher`;
export const API_DEPARTMENT_ID = `${API}intranetprofiles/v1/api/cms/association/getAreas`;
export const API_DEPARTMENT_HCM = `${API}intranetemployee/v1/api/public/v1/hcm/departments`;
export const API_DEPARTMENT_DATA = `${API}intranetprofiles/v1/api/public/association`;
export const API_PUBLIC_DOCUMENTS = `${API}intranetcms/v1/api/public/documents`;
export const API_PAYROLL = `${API}intranetemployee/v1/api/public/payslip`;
export const API_LOCATIONS = `${API}intranetemployee/v1/api/public/user/locations`;
export const API_PAYROLL_INCIDENCE = `${API}intranetsocial/v1/api/sendmail/employeeAttencionBox`;
export const API_INBOX_INCIDENCE = `${API}intranetsocial/v1/api/sendmail/suggestionsBox`;
export const API_DEPARTMENT_TEAM = `${API}intranetprofiles/v1/api/public/department/0000/myteam`;
export const API_USER_LIST_TEAM = `${API}intranetprofiles/v1/api/user/myteam`;
export const API_PUBLIC_ADDRESS = `${API}intranetemployee/v1/api/public/address`;
export const API_PUBLIC_BANK = `${API}intranetemployee/v1/api/public/bank`;
export const API_IRPF_DATA = `${API}intranetemployee/v1/api/public/irpf/irpfdata`;
export const API_RADIO_STATIONS = `${API}intranetemployee/v1/api/public/radiostations`;
export const API_ACCESS_CONTROL = `${API}intranetemployee/v1/api/public/accesscontrol`;
export const API_CREATE_EXCEL_ACCESS_CONTROL = `${API}intranetemployee/v1/api/public/accesscontrol/createExcel`;
export const API_RADIO_BROADCASTERS = `${API}intranetemployee/v1/api/public/radiobroadcasters`;
export const API_RADIO_RENTAL = `${API}intranetemployee/v1/api/public/radiobroadcasters/radiostationrental`;
export const API_LAST_MINUTE = `${API}intranetcms/v1/api/public/latestinformation`;
export const API_LOGIN = `${API}login`;
export const API_LOGIN_AZURE = `${API}loginAzure`;
export const API_LOGOUT = `${API}logout`;
export const API_LEGAL = `${API}intranetprofiles/v1/api/user/legalConditions`;
export const API_DEPARTMENT = `${API}intranetprofiles/v1/api/public/department`;
export const API_POSITION = `${API}intranetprofiles/v1/api/public/groups/userJobPositions`;
export const API_GROUPS = `${API}intranetprofiles/v1/api/public/groups/`;
export const API_PROFILE_CMS = `${API}intranetprofiles/v1/api/cms`;
export const API_FOLDER = `${API}intranetcms/v1/api/public/folders`;
export const API_TAGS = `${API}intranettags/v1/api/`;
